<script setup>
// Preview do e-mail: o HTML vem RENDERIZADO do servidor (mesmo que vai pro
// destinatário) e entra num iframe isolado. Desktop = 600px, celular = 375px.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  html: { type: String, default: '' },
  device: { type: String, default: 'desktop' },
  dark: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  sizeKb: { type: Number, default: 0 },
});
const { t } = useI18n();

const widthClass = computed(() =>
  props.device === 'mobile' ? 'w-[375px]' : 'w-[680px]'
);
// Gmail corta acima de ~102 KB: avisa antes.
const heavy = computed(() => props.sizeKb > 95);
</script>

<template>
  <div
    class="relative flex h-full min-h-0 flex-1 flex-col items-center overflow-auto p-6"
    :class="dark ? 'bg-[#0b1220]' : 'bg-n-solid-3'"
  >
    <div
      class="max-w-full shrink-0 overflow-hidden rounded-xl shadow-lg transition-all"
      :class="widthClass"
    >
      <iframe
        :srcdoc="html"
        sandbox=""
        :title="t('EMAIL_TEMPLATES.PREVIEW')"
        class="block h-[1400px] w-full border-0 bg-white"
      />
    </div>
    <div
      class="pointer-events-none absolute right-4 top-3 flex items-center gap-2 text-[11px]"
    >
      <span
        v-if="loading"
        class="rounded-md bg-n-solid-1 px-2 py-1 text-n-slate-10 shadow"
      >
        {{ t('EMAIL_TEMPLATES.BUILDER.PREVIEW.UPDATING') }}
      </span>
      <span
        v-else-if="sizeKb"
        class="rounded-md px-2 py-1 shadow"
        :class="
          heavy
            ? 'bg-n-amber-3 text-n-amber-11'
            : 'bg-n-solid-1 text-n-slate-10'
        "
      >
        {{ t('EMAIL_TEMPLATES.BUILDER.PREVIEW.SIZE', { kb: sizeKb }) }}
      </span>
    </div>
  </div>
</template>
